import React, { useState, useCallback } from "react";
import { observer } from "mobx-react-lite";
import { useTheme } from '~/ui/styled'
import { Flex, ColumnFlex, StartFlex, BetweenFlex, Text, Button, GradientButton, IconFont } from "~components/El"
import { SearchBar } from "~components/SearchBar"
import { FlatList } from "~widgets/flat-list"
import { useStores } from "~models"
import MemberListItem from "~/components/contact-list/components/member-list-item"

const MemberListView: React.FC<{
    type: "redPacket" | "transfer"; 
    onMemberChange: (member: any) => void;
    onClose: () => void
}> = ({ type = 'redPacket', onMemberChange, onClose }) => {
    const theme = useTheme()
    const { chatStore, userStore } = useStores()
    const [searchText, setSearchText] = useState("")
    const data = chatStore.currentMembers || []
    const currentUser = userStore.currentUser
    const filteredData = data.filter(item => item.user_id !== currentUser?.id)
    const keyExtractor = useCallback((item, idx) => item.user_id || idx.toString(), [])
    return (
        <ColumnFlex
            width="100%"
            height="auto"
            padding="20px"
            borderRadius="16px"
            bg={theme.colors.blockBackground}
        >
            <Flex width="100%">
                <GradientButton
                    width={34}
                    height={34}
                    colors={['#fb994d', '#ee4b49']}
                    borderRadius={17}
                    onClick={() => { } }
                >
                    <IconFont name="nc" color={theme.colors.textLight} size={16} />
                </GradientButton>
                <Flex height="auto" flexDirection="column" ml="10px">
                    <Text fontSize="16px" color={theme.colors.text} fontWeight={600}>{type === 'transfer' ? '选择转账对象' : '选择红包领取人'}</Text>
                    <Text fontSize="12px" color={theme.colors.secondary}>{chatStore.currentMembers.length}位成员</Text>
                </Flex>
            </Flex>
            <StartFlex height="auto" mt="20px">
                <SearchBar
                    value={searchText}
                    placeholder="搜索联系人"
                    onChange={setSearchText}
                    onClear={() => setSearchText("")}
                />
            </StartFlex>
            <StartFlex height="auto" style={{ maxHeight: 360 }}>
                <FlatList
                      data={filteredData}
                      keyExtractor={keyExtractor}
                      renderItem={({ item, selecteds }) => {
                        return (
                          <MemberListItem member={item} selecteds={selecteds} onItemClick={onMemberChange} />
                        )
                      }}
                    />
            </StartFlex>
            <BetweenFlex width="100%" mt="12px">
                <Button
                    width="100%"
                    height="44px"
                    borderRadius={theme.radii.lg}
                    bg={theme.colors.background}
                    onClick={onClose}
                >
                    <Text color={theme.colors.infoText} fontSize={16}>取消</Text>
                </Button>
            </BetweenFlex>
        </ColumnFlex>
    )
}

export default observer(MemberListView)
